<ng-template #content>
  <div fxLayout="row" fxLayoutAlign="center center">
    <div [style.visibility]="loading ? 'hidden' : 'visible'">
      <ng-content></ng-content>
    </div>
    <div [ngClass]="['loader', customType, color ? color : '']" *ngIf="loading">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <div></div>
  </div>
</ng-template>

<button
  mat-button
  *ngIf="customType === loaderButtonType.STANDARD"
  (click)="onButtonClick($event)"
  [color]="color"
  type="{{ buttonType }}"
  [disabled]="disabled || loading"
  fxLayout="row"
  [style]="style"
  fxLayoutAlign="center center"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>

<button
  [class.new-loader-btn-green]="billtechPayMode"
  mat-raised-button
  *ngIf="customType === loaderButtonType.RAISED"
  (click)="onButtonClick($event)"
  [color]="color"
  type="{{ buttonType }}"
  [disabled]="disabled || loading"
  fxLayout="row"
  [style]="style"
  fxLayoutAlign="center center"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>

<button
  mat-flat-button
  *ngIf="customType === loaderButtonType.FLAT"
  (click)="onButtonClick($event)"
  [color]="color"
  type="{{ buttonType }}"
  [disabled]="disabled || loading"
  fxLayout="row"
  [style]="style"
  fxLayoutAlign="center center"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>

<button
  mat-stroked-button
  *ngIf="customType === loaderButtonType.STROKE"
  (click)="onButtonClick($event)"
  [color]="color"
  type="{{ buttonType }}"
  [disabled]="disabled || loading"
  fxLayout="row"
  [style]="style"
  fxLayoutAlign="center center"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>

<button
  mat-icon-button
  *ngIf="customType === loaderButtonType.ICON"
  (click)="onButtonClick($event)"
  [color]="color"
  type="{{ buttonType }}"
  [disabled]="disabled || loading"
  fxLayout="row"
  [style]="style"
  fxLayoutAlign="center center"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>
<button
  mat-button
  *ngIf="customType === loaderButtonType.OUTLINE"
  (click)="onButtonClick($event)"
  class="outline-button"
  type="button"
  [disabled]="disabled || loading"
  fxLayout="row"
  [style]="style"
  fxLayoutAlign="center center">
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>

